import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { WindowService } from 'src/shared/providers/window.service';
import { UrlStateService } from 'src/shared/services/url-state.service';

type ComplianceTab = 'compliance' | 'noise-monitoring' | 'renter-agreements' | 'insurance';

@Component({
  templateUrl: 'compliance.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CompliancePage implements OnInit {
  readonly windowService = inject(WindowService);

  private readonly route = inject(ActivatedRoute);
  private readonly urlStateService = inject(UrlStateService);
  private readonly destroyRef = inject(DestroyRef);

  loaded = false;
  isSavingStatus = false;
  selectedTab: ComplianceTab = 'compliance';

  tabs: { value: ComplianceTab; label: string; icon?: string }[] = [
    { value: 'compliance', label: 'Compliance', icon: 'assets/svg/shield-checkmark-outline.svg' },
    { value: 'noise-monitoring', label: 'Noise Monitoring', icon: 'assets/svg/volume-high-outline.svg' },
    // { value: 'renter-agreements', label: 'Renter Agreements', icon: 'assets/svg/document-text-outline.svg' },
    { value: 'insurance', label: 'Insurance', icon: 'assets/svg/shield-outline.svg' },
  ];

  get tabTitle(): string {
    return this.tabs.find(t => t.value === this.selectedTab)?.label ?? 'Compliance';
  }

  ngOnInit() {
    this.loaded = true;

    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        if (params['tab'] && this.tabs.some(t => t.value === params['tab'])) {
          this.selectedTab = params['tab'] as ComplianceTab;
        }
      });
  }

  selectTab(tab: string) {
    this.selectedTab = tab as ComplianceTab;
    this.urlStateService.updateQueryParams({ tab });
  }
}
